import { Grid, Skeleton, Stack } from '@mui/material';
import React from 'react';
const ResumeDialogSkeleton = () => {
  return (
    <Grid
      container
      justifyContent='space-between'
      sx={{
        py: 2,
      }}
    >
      <Stack width='100%' gap={0.5}>
        <Stack flexDirection={'row'} alignContent={'center'} sx={{ px: 2 }}>
          <Skeleton
            data-testid='download-link-shimmer'
            sx={{
              bgcolor: (theme) => theme.palette.neutral?.main,
              flexGrow: 1,
            }}
            variant='rectangular'
            height={24}
            width={24}
            animation='wave'
          />
          <Stack
            flexDirection={'column'}
            justifyContent={'center'}
            alignContent={'center'}
            alignItems={'center'}
            gap={0.5}
            sx={{ flexGrow: 8 }}
          >
            {[...Array(2)].map((_, i) => (
              <Skeleton
                key={i}
                sx={{ bgcolor: (theme) => theme.palette.neutral?.main }}
                variant='rectangular'
                height={24}
                width={100}
                animation='wave'
              />
            ))}
          </Stack>
        </Stack>
        <Skeleton
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
            my: 1,
          }}
          variant='rectangular'
          height={3}
          width={'100%'}
          animation='wave'
        />
        <Stack sx={{ px: 2 }}>
          <Skeleton
            sx={{
              bgcolor: (theme) => theme.palette.neutral?.main,
            }}
            variant='rectangular'
            height={25}
            width={77}
            animation='wave'
          />
        </Stack>
        <Stack sx={{ px: 2 }}>
          <Skeleton
            sx={{
              bgcolor: (theme) => theme.palette.neutral?.main,
              px: 2,
            }}
            variant='rectangular'
            height={500}
            width='100%'
            animation='wave'
          />
        </Stack>
      </Stack>
    </Grid>
  );
};

export default ResumeDialogSkeleton;
